const FEATURE_FLAGS = {
  common: {
    advisory: {
      /** Is advisory currency enabled? */
      enabled: 'common.enableAdvisoryCurrency',

      /** Enables opt out */
      optOutEnabled: 'common.advisory.enableOptOut'
    },
    searchResults: {
      /** Is parking button enabled? */
      isParkingEnabled: 'common.searchResults.isParkingEnabled'
    },
    seatDetails: {
      /** Shows missing option in traits modal */
      missingOption: 'common.traits.modal.missingOption'
    },
    altBrand: {
      useAltBrand: 'common.useAltBrand'
    },
    auth: {
      sessionAuthEnabled: 'common.sessionAuthEnabled'
    },
    faceValue: {
      MandatoryEnabled: 'common.faceValue.MandatoryEnabled',
      eventBasedEnabled: 'common.faceValue.eventBasedEnabled'
    },
    EUBankAccountEnabled: 'common.EUBankAccountBannerEnabled',
    tns: {
      /** Is tns simility enabled? */
      simility: 'common.tns.isSimilityOn'
    },

    /** Feature toggle for GTM */
    enableBranchIO: 'common.enableBranchIO',

    /** Is cookies modal enabled? */
    cookiesModal: 'common.cookiesModal.show',

    /** Is DSA active? */
    isDsaActive: 'common.isDsaActive',

    /** Is DSA extra fields active? */
    isDsaExtraFieldsActive: 'common.isDsaExtraFieldsActive',
  },
  sell: {
    hyperwallet: {
      /** Show the warning informing to add the payment methods again after the hyperwallet ithaca migration */
      showAddPaymentMethodWarning: 'sell.hyperwallet.showAddPaymentMethodWarning'
    },
    sellerInfo: {
      /** Show the message to be considered as a business seller  */
      showPrivateSellerOption: 'sell.sellerInfo.showPrivateSellerOption'
    },
  }
};

export default FEATURE_FLAGS;
